import { ITaxationDrawerInfo } from '.';
import PrecisionService from '@services/PrecisionService';
import { trimTrailingZeros } from '@utils/formatting-utils';
import { lookupListAsRecordObject } from '@utils/graph-utils';

export function toLookups(data: any) {
  const taxationEnums: Record<string, Record<string, string>> = {};
  const line: Record<string, string> = {};

  data.PlanConfigManagement.queries.allLines.forEach(
    (element: {
      planConfigManagement_Line_Id: string;
      planConfigManagement_Line_Name: string;
    }) => {
      line[element.planConfigManagement_Line_Id] =
        element.planConfigManagement_Line_Name;
    }
  );

  taxationEnums['line'] = line;

  return taxationEnums;
}

export function graphqlToTaxationInfo(data: any): ITaxationDrawerInfo {
  const taxation =
    data?.Configuration?.entities?.taxation?.views?.Configuration_all
      ?.properties;
  const line = taxation?.LineID?.views?.PlanConfigManagement_all?.properties;

  return {
    line: taxation?.LineID?.id,
    lineTitle: `${line?.ExternalCode} - ${line?.Name}`,
    fixedStampCurrency: taxation?.FixedStampCurrency?.Code,
    fixedStamp: taxation?.FixedStamp,
    proportionalStamp: trimTrailingZeros(
      PrecisionService.multiplyBy100(Number(taxation?.ProportionalStamp))
    ),
    municipalityTax: trimTrailingZeros(
      PrecisionService.multiplyBy100(Number(taxation?.MunicipalityTax))
    ),
    taxOnCommission: trimTrailingZeros(
      PrecisionService.multiplyBy100(Number(taxation?.TaxOnCommission))
    ),
    reinsuranceTax: trimTrailingZeros(
      PrecisionService.multiplyBy100(Number(taxation?.ReinsuranceTax))
    ),
    effectiveFrom: taxation?.EffectiveFrom,
    effectiveTo: taxation?.EffectiveTo,
  };
}

export function extractLines(data: any) {
  const lines: Record<string, string> = {};

  data.PlanConfigManagement.queries.allLines.forEach(
    (element: {
      planConfigManagement_Line_Id: string;
      planConfigManagement_Line_Name: string;
      planConfigManagement_Line_ExternalCode: string;
    }) => {
      lines[element.planConfigManagement_Line_Id] =
        `${element.planConfigManagement_Line_ExternalCode} - ${element.planConfigManagement_Line_Name}`;
    }
  );

  return lines;
}

export function extractLatestTaxationByLine(data: any) {
  const taxation = data?.Configuration?.queries?.getLatestTaxationByLine[0];
  return {
    fixedStampCurrency:
      taxation?.configuration_Taxation_FixedStampCurrency?.Code,
    fixedStamp: taxation?.configuration_Taxation_FixedStamp,
    proportionalStamp: `${trimTrailingZeros(
      PrecisionService.multiplyBy100(
        Number(taxation?.configuration_Taxation_ProportionalStamp)
      )
    )}`,
    municipalityTax: `${trimTrailingZeros(
      PrecisionService.multiplyBy100(
        Number(taxation?.configuration_Taxation_MunicipalityTax)
      )
    )}`,
    taxOnCommission: `${trimTrailingZeros(
      PrecisionService.multiplyBy100(
        Number(taxation?.configuration_Taxation_TaxOnCommission)
      )
    )}`,
    reinsuranceTax: `${trimTrailingZeros(
      PrecisionService.multiplyBy100(
        Number(taxation?.configuration_Taxation_ReinsuranceTax)
      )
    )}`,
    effectiveFrom: taxation?.configuration_Taxation_EffectiveFrom,
  };
}
